{
  "selectPlaceholder": "Select an item",
  "tableResizer": "Resizer",
  "dropzoneLabel": "DropZone",
  "expand": "Expand",
  "collapse": "Collapse"
}
